import { useState } from "react";
import { CheckCircle, WhatsappLogo } from "@phosphor-icons/react";
import { toast } from "sonner";
import { GoldButton } from "../GoldButton";
import { INTERESSES, waLink } from "../../config/site";

export const LeadForm = () => {
  const [nome, setNome] = useState("");
  const [whats, setWhats] = useState("");
  const [interesse, setInteresse] = useState("");
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!nome.trim() || !whats.trim()) {
      toast.error("Preencha nome e WhatsApp para continuar.");
      return;
    }
    const linha = interesse ? ` Tenho interesse na turma: ${interesse}.` : "";
    const msg = `Oi! Sou ${nome.trim()} (WhatsApp ${whats.trim()}). Quero minha aula experimental gratuita na Templo Savassi.${linha}`;
    setSent(true);
    toast.success("Tudo certo! Abrindo o WhatsApp da Templo…");
    window.open(waLink(msg), "_blank", "noopener,noreferrer");
  };

  const inputCls =
    "w-full bg-transparent border-b border-ink/15 py-4 font-body text-[16px] text-ink placeholder:text-slate/40 focus:border-gold focus:outline-none transition-colors duration-300";

  return (
    <section
      id="lista"
      data-testid="lead-form-section"
      className="relative py-24 md:py-32 bg-sand"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
        <span className="font-body text-xs tracking-[0.3em] uppercase text-gold">
          Aula experimental
        </span>
        <h2 className="font-display text-ink uppercase tracking-tight leading-[0.95] text-4xl md:text-5xl lg:text-6xl mt-5">
          Comece pela sua aula experimental gratuita
        </h2>

        {sent ? (
          <div
            data-testid="lead-form-success"
            className="mt-12 rounded-2xl border border-gold/40 bg-paper p-10 flex flex-col items-center gap-4 shadow-[0_20px_50px_rgba(184,134,46,0.12)]"
          >
            <CheckCircle size={48} weight="thin" className="text-gold" />
            <p className="font-display text-ink uppercase tracking-[0.12em] text-2xl">
              Recebemos seu interesse!
            </p>
            <p className="font-body text-slate/70 max-w-md">
              Estamos abrindo o WhatsApp da Templo para confirmar sua aula.
              Se não abrir automaticamente, toque no botão abaixo.
            </p>
            <GoldButton
              href={waLink(
                `Oi! Sou ${nome.trim()}. Quero minha aula experimental gratuita na Templo Savassi.`
              )}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="lead-form-open-whatsapp"
            >
              <WhatsappLogo size={18} weight="fill" />
              Abrir WhatsApp
            </GoldButton>
          </div>
        ) : (
          <form
            onSubmit={submit}
            className="mt-12 text-left flex flex-col gap-7"
            data-testid="lead-form"
          >
            <input
              type="text"
              placeholder="Seu nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              className={inputCls}
              data-testid="lead-input-nome"
            />
            <input
              type="tel"
              placeholder="Seu WhatsApp (com DDD)"
              value={whats}
              onChange={(e) => setWhats(e.target.value)}
              className={inputCls}
              data-testid="lead-input-whatsapp"
            />
            <div className="relative">
              <select
                value={interesse}
                onChange={(e) => setInteresse(e.target.value)}
                className={`${inputCls} appearance-none cursor-pointer ${
                  interesse ? "text-ink" : "text-slate/40"
                }`}
                data-testid="lead-select-interesse"
              >
                <option value="">Interesse (opcional)</option>
                {INTERESSES.map((it) => (
                  <option key={it} value={it}>
                    {it}
                  </option>
                ))}
              </select>
              <span className="pointer-events-none absolute right-1 top-4 text-gold">
                ▾
              </span>
            </div>

            <GoldButton
              as="button"
              type="submit"
              className="w-full mt-2 text-base py-4"
              data-testid="lead-submit"
            >
              <WhatsappLogo size={20} weight="fill" />
              Quero minha aula experimental
            </GoldButton>
          </form>
        )}
      </div>
    </section>
  );
};
